export enum DateRangeTypeEnum {
	LastHour = 'Last hour',
	LastDay = 'Last day',
	LastWeek = 'Last week',
	LastMonth = 'Last month',
	LastQuarter = 'Last quarter',
	Custom = 'Custom',
}
